import { Injectable } from '@angular/core';
import { MessageData } from './messageData';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Chats } from '../interfaces/chatData';
import { NoteRequest } from '../interfaces/userchatcrm';
import { Country } from '../interfaces/Country';
import { Suscriptions } from '../interfaces/suscription.interface';


@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  private countriesUrl = 'assets/countries.json';
  private baseApi = environment.baseApi + '/chats';
  private baseApiNormal = environment.baseApi
  private contactoChat = new Subject<any>();
  private contactoNuevoChat = new Subject<any>();
  private dispositivo = new BehaviorSubject<Suscriptions | null>(null);
  private status = new Subject<number>();
  private selectedChatSource = new BehaviorSubject<Chats | null>(null);
  selectedChat$ = this.selectedChatSource.asObservable();
  // private showUserSource = new Subject<number>();
  // showUser$ = this.showUserSource.asObservable();
  private messagesSource = new BehaviorSubject<MessageData[]>([]);
  messages$ = this.messagesSource.asObservable();
  private notesSubject = new BehaviorSubject<NoteRequest[]>([]);
  notes$ = this.notesSubject.asObservable();
  private idStatusSubject = new BehaviorSubject<number | null>(null);
  idStatus$ = this.idStatusSubject.asObservable();
  private chats = new BehaviorSubject<Chats[]>([]);
  chatList$ = this.chats.asObservable();
  private selectedStatusSource = new BehaviorSubject<number | null>(null);
  selectedStatus$ = this.selectedStatusSource.asObservable();
  private searchTermSubject = new BehaviorSubject<string>('');
  searchTerm$ = this.searchTermSubject.asObservable();
  private pageSubject = new Subject<any>();
  page$ = this.pageSubject.asObservable();
  private messageCountSubject = new Subject<any>();
  messageCount$ = this.messageCountSubject.asObservable();
  private showUserSubject = new BehaviorSubject<number | null>(null);
  showUser$ = this.showUserSubject.asObservable();


  constructor(private http: HttpClient) { }

  async getConversations(idSuscription: any, idStatus: number | null, idUser?: number, page?: any): Promise<any> {
    let url: string;
  
    if (idUser !== undefined) {
      // Si se proporciona idUser, es un usuario, incluye ese parámetro en la URL
      if (idStatus === undefined || idStatus === null || idStatus === 0 ) {
        // Si idStatus es 0, solo necesita el parámetro idSuscription
        url = `${this.baseApi}/user/${idSuscription}/${idUser}`;
      } else {
        // Si idStatus no es 0, incluye ambos parámetros
        url = `${this.baseApi}/user/${idSuscription}/${idUser}/${idStatus}`;
      }
    } else {
      // Si no se proporciona idUser, es un cliente (customer)
      if (idStatus === undefined || idStatus === null || idStatus === 0 ) {
        // Si idStatus es 0, solo necesita el parámetro idSuscription
        url = `${this.baseApi}/${idSuscription}`;
      } else {
        // Si idStatus no es 0, incluye ambos parámetros
        url = `${this.baseApi}/${idSuscription}/${idStatus}`;
      }
    }
    
    // Verifica si page es diferente de 0, y si es así, agrega el parámetro a la URL
    if (page !== null && page !== undefined) {
      url += `?page=${page}`;
    }
    return await this.http.get<any>(url).toPromise();
  }
  

  getChatId(countryCode: number, number: string, idDispositivo: number){
    return this.http.get<any>(`${this.baseApi}/chatId/${countryCode}/${number}/${idDispositivo}`).toPromise();
  }

  async getMessages(chatId: string | undefined, idSuscription: number | null, page: number, pageSize: number) {
    return this.http.get<any>(`${this.baseApi}/messages/${chatId}/${idSuscription}?page=${page}&pageSize=${pageSize}`).toPromise();
  }
  

  getNotesForChat(chatId: string | undefined){
    return this.http.get<any>(`${this.baseApiNormal}/notes/${chatId}`).toPromise();
  }

  sendImage(idSuscription: number, idCustomer: number, formData: FormData) {
    const headers = new HttpHeaders();
    return this.http.post<any>(
      `${this.baseApi}/send-image/${idSuscription}/${idCustomer}`,
      formData,  {headers}
    ).toPromise();
  }
  

  sendFile(idSuscription: number, idCustomer: number, body: any) {
    const headers = new HttpHeaders();
    return this.http.post<any>(`${this.baseApi}/send-file/${idSuscription}/${idCustomer}`, body, {headers}).toPromise();
  }

  sendLocation(idSuscription: any, idCustomer: number, body: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(`${this.baseApi}/send-location/${idSuscription}/${idCustomer}`, body, {headers}).toPromise();
  }

  changeUser(idSuscription: number, chatId: string | undefined, idUser: number | null | undefined) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<Response>(`${this.baseApi}/change-user/${idSuscription}/${chatId}/${idUser}`, { headers })
  }

  establecerChatLeido(idSuscription: number, chatId: string | undefined) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<Response>(`${this.baseApi}/set-read/${idSuscription}/${chatId}`, { headers }).toPromise();
  }

  enviarChat(data: any) {
    this.contactoChat.next(data);
  }

  obtenerChat() {
    return this.contactoChat.asObservable();
  }

  infoContacto(data: any) {
    this.contactoNuevoChat.next(data)
  }

  obtenerInfoContacto() {
    return this.contactoNuevoChat.asObservable();
  }

  
  setDispositivo(data: any) {
    this.dispositivo.next(data)
  }
  dispositivo$() {
    return this.dispositivo.asObservable();
  }
  get dispositivoValue(): any {
    return this.dispositivo.value;
  }

  establecerEstatus(idStatus: any){
    this.status.next(idStatus)
  }

  obtenerStatus(){
    return this.status.asObservable()
  }

  setSelectedChat(chat: Chats | null) {
    this.selectedChatSource.next(chat);
  }

  getSelectedChat() {
    return this.selectedChatSource.asObservable()
  }

  setShowUser(idUser: number) {
    this.showUserSubject.next(idUser);
  }

  getShowUser() {
    return this.showUserSubject.asObservable();
  }

  setMessages(messages: MessageData[]) {
    this.messagesSource.next(messages);
  }

  setChats(chats: Chats[]) {
    this.chats.next(chats);
  }

  obtenerChats() {
    return this.chats.asObservable();
  }

  obtenerMensajes() {
    return this.messagesSource.asObservable();
  }

  updateNotes(notes: NoteRequest[]) {
    this.notesSubject.next(notes);
  }

  updateIdStatus(idStatus: number | null) {
    this.idStatusSubject.next(idStatus);
  }

  obtenerIdStatus(){
    return this.idStatusSubject.asObservable();
  }

  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(this.countriesUrl);
  }

  updateSearchTerm(term: string) {
    this.searchTermSubject.next(term);
  }

  setPage(page: any){
    this.pageSubject.next(page)
  }

  getPage(){
    return this.pageSubject.asObservable()
  }

  setMessageCount(page: any){
    this.messageCountSubject.next(page)
  }

  getMessageCount(){
    return this.messageCountSubject.asObservable()
  }
}
